import { ExternalLink, ShoppingBag, Users } from 'lucide-react'

import { buttonVariants } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { cn } from '@/lib/utils'

import links from '../lib/third-party-links.json'

type ThirdPartyLinks = {
  xianyu?: { url?: string; title?: string; description?: string }
  support?: {
    xiaohongshuProfileUrl?: string
    xiaohongshuHandle?: string
    note?: string
  }
}

const CONFIG = links as unknown as ThirdPartyLinks

export function ThirdPartyPurchaseCard() {
  const xianyu = CONFIG.xianyu
  const support = CONFIG.support ?? {}

  if (!xianyu?.url && !support.xiaohongshuProfileUrl) return null

  return (
    <Card>
      <CardHeader className='border-b p-3 !pb-3 sm:p-5 sm:!pb-5'>
        <div className='flex items-center gap-3'>
          <span className='bg-muted flex size-9 shrink-0 items-center justify-center rounded-lg'>
            <ShoppingBag className='size-4' />
          </span>
          <div>
            <h3 className='font-medium'>{xianyu?.title ?? '购买兑换码'}</h3>
            <p className='text-muted-foreground text-sm'>
              {xianyu?.description ?? '站外下单后回到本页兑换到账。'}
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent className='space-y-4 p-3 sm:p-5'>
        <div className='flex flex-wrap gap-2'>
          {xianyu?.url && (
            <a
              href={xianyu.url}
              target='_blank'
              rel='noreferrer'
              className={cn(buttonVariants({ variant: 'default' }), 'gap-1.5')}
            >
              打开闲鱼商品
              <ExternalLink className='size-4' />
            </a>
          )}
          {support.xiaohongshuProfileUrl && (
            <a
              href={support.xiaohongshuProfileUrl}
              target='_blank'
              rel='noreferrer'
              className={cn(buttonVariants({ variant: 'outline' }), 'gap-1.5')}
            >
              <Users className='size-4' />
              小红书主页{support.xiaohongshuHandle ? `（${support.xiaohongshuHandle}）` : ''}
            </a>
          )}
        </div>

        {support.note && (
          <p className='text-muted-foreground text-xs'>{support.note}</p>
        )}
      </CardContent>
    </Card>
  )
}
